<template>
  <div class="container">
    <div class="flex flex-col md:flex-row">
      <div class="w-full md:w-1/3">
        <h4 class="text-gray-900 text-lg">Send From</h4>
      </div>
      <div class="w-full md:w-2/3">
        <vs-card class="p-5 mb-0">
          <a-form-item label="Email">
            <a-input placeholder="SamuelArash@gmail.com" style="width: 300px"></a-input>
          </a-form-item>
        </vs-card>
      </div>
    </div>
    <a-divider/>
    <div class="flex flex-col md:flex-row">
      <div class="w-full md:w-1/3">
        <h4 class="text-gray-900 text-lg">Recipient Details</h4>
      </div>
      <div class="w-full md:w-2/3">
        <vs-card class="p-5 mb-0">
          <selectSearch
              :required="true"
              url="/contact/query/"
              :options="{
                  placeholder: 'Search contacts',
                  label: 'Contact',
                  field: 'contact',
                  width: '300px',
                  allow_clear: true
              }"
              class="self-center mt-8 md:mt-0 w-full"
              :is_include_matter="false"
            />
          <a-checkbox class="mt-5">Send client fund requests to all recipients via one email</a-checkbox>
        </vs-card>
      </div>
    </div>
    <a-divider/>
    <div class="flex flex-col md:flex-row">
      <div class="w-full md:w-1/3">
        <h4 class="text-gray-900 text-lg">Message Details</h4>
      </div>
      <div class="w-full md:w-2/3">
        <vs-card class="p-5 mb-0">
          <a-form-item label="Email template">
            <a-select :defaultValue="1" style="width: 300px">
              <a-select-option :value="1">Default Client Funds template</a-select-option>
              <a-select-option :value="2">Default Client Funds template</a-select-option>
              <a-select-option :value="3">Default Client Funds template</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Subject">
            <a-input />
          </a-form-item>
          <a-form-item label="Body">
            <a-textarea :rows="5"/>
          </a-form-item>
          <a-form-item label="Additional Settings">
            <a-radio-group>
              <a-radio :style="radioStyle" :value="1">Email With PDF via source link</a-radio>
              <a-radio :style="radioStyle" :value="2">Email With PDF attachment</a-radio>
              <a-radio :style="radioStyle" :value="3">Clio Connect</a-radio>
            </a-radio-group>
          </a-form-item>
        </vs-card>
      </div>
    </div>
    <a-divider/>
    <div class="flex flex-col md:flex-row">
      <div class="w-full md:w-1/3">
        <h4 class="text-gray-900 text-lg">Email Notification preview</h4>
      </div>
      <div class="w-full md:w-2/3">
        <vx-card title="Preview" class="p-5 mb-0">
          <div class="m-auto text-center">
            <img src="../../assets/images/bill/previewBill.svg" width="400" class="m-auto"/>
            <div class="font-bold">No recipients selected</div>
            <div>Select a recipient th see the preview</div>
          </div>
        </vx-card>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import SelectSearch from "@/views/forms/selectSearch";
import mixin from '../mixin/mixin'
import Footer from "@/views/footer/Footer";
export default {
  name: "BillingRequestFund",
  mixins:[mixin],
  components: {Footer, SelectSearch}
}
</script>

<style scoped>

</style>
